"use client";

import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
const properties = [{
  id: 1,
  title: "Rajalansaari | Pälkäneen kunta (2026)",
  description: "Musiikkivideo Rajalansaaren luonto- ja retkikohteesta. Projekti yhdisti alkuperäisen musiikin, videotuotannon, dronekuvauksen ja tarinankerronnan yhdeksi kokonaisuudeksi.\nRooli: Sävellys, sovitus, videokuvaus, dronekuvaus, editointi, äänitys, miksaus ja masterointi.",
  image: "https://dialogimediatuotanto.com/wp-content/uploads/2026/06/Rajalansaari-scaled.jpg?v=dxe0g7pzmba",
  srcset: "https://dialogimediatuotanto.com/wp-content/uploads/2026/06/Rajalansaari-scaled.jpg?v=n4e2gpbcg9",
  sizes: "https://dialogimediatuotanto.com/wp-content/uploads/2026/06/Rajalansaari-scaled.jpg?v=jkedq0xbln8",
  link: "https://www.youtube.com/watch?v=-3k4thA8v3I",
  category: "MATKAILUA JA TARINANKERRONTAA YHDISTÄVÄ MUSIIKKIVIDEOTUOTANTO",
  year: "2026"
}, {
  id: 2,
  title: "Ping Helsinki | Videopodcast-sarja (2024)",
  description: "Viisiosainen monikamerainen videopodcast-sarja Ping Helsingille. Tuotanto sisälsi kuvauksen, editoinnin sekä sosiaalisen median teaser-sisällöt.\nRooli: Monikameratuotanto, editointi, tekstitys, äänen jälkikäsittely ja teaser-videot.",
  image: "https://dialogimediatuotanto.com/wp-content/uploads/2026/06/Videopodcast.jpg?v=932e1kxmxb",
  srcset: "https://dialogimediatuotanto.com/wp-content/uploads/2026/06/Videopodcast.jpg?v=9macwel0tis",
  sizes: "https://dialogimediatuotanto.com/wp-content/uploads/2026/06/Videopodcast.jpg?v=lggq9mpkkxd",
  link: "https://www.youtube.com/@Muutostoissa/videos",
  category: "VIISIOSAINEN VIDEOPODCAST-SARJA",
  year: "2024"
}, {
  id: 3,
  title: "Emilia Aarnio | Musiikkivideo (2024)",
  description: "Tarinallinen musiikkivideo artistijulkaisuun. Tavoitteena oli rakentaa kappaleen tunnelmaa tukeva visuaalinen kokonaisuus.\nRooli: äänitys, miksaus ja masterointi, videokuvaus, editointi, värimäärittely ja tuotanto.",
  image: "https://dialogimediatuotanto.com/wp-content/uploads/2026/06/Lentakaa-scaled.jpg?v=5es5ymfgllg",
  srcset: "https://dialogimediatuotanto.com/wp-content/uploads/2026/06/Lentakaa-scaled.jpg?v=e4usewxykt",
  sizes: "https://dialogimediatuotanto.com/wp-content/uploads/2026/06/Lentakaa-scaled.jpg?v=l59h2tmqth",
  link: "https://www.youtube.com/watch?v=MiuQfG7sbJQ",
  category: "TARINALLINEN MUSIIKKIVIDEOTUOTANTO",
  year: "2024"
}];
export default function ValikoitujaProjekteja() {
  return <section data-section-id="3335" id="referenssit" className="bg-secondary text-foreground font-default">
      <div className="px-6 md:px-12 lg:px-16 py-12 md:py-16">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-7 md:col-start-2">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground mb-6 md:mb-8">N° 01 — Tuotannot</p>
            <h1 className="font-default text-5xl leading-[1.05] tracking-tight font-bold !text-[rgba(24,46,78,1)] md:text-6xl lg:text-7xl">
              Valikoituja <em className="italic font-serif font-light">tuotantoja</em>
            </h1>
          </div>
        </div>
      </div>

      <div className="px-6 md:px-12 lg:px-16 pb-24 md:pb-32">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-16">
          {properties.map((project, i) => <article key={project.id} data-index={i} className="group flex flex-col">
              <div className="relative overflow-hidden aspect-[16/9] bg-muted rounded-md shadow-md">
                <div className="absolute top-0 left-0 right-0 h-px bg-primary scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left z-10" />
                <img src={project.image} data-wvc-srcset={project.srcset} data-wvc-sizes={project.sizes} alt={project.title} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" />
                <Badge className="absolute top-4 left-4 font-mono text-[10px] uppercase tracking-[0.15em] rounded-md px-2.5 py-1 border-0 bg-primary text-primary-foreground">
                  {project.year}
                </Badge>
              </div>

              <div className="flex items-baseline justify-between mt-6 gap-4">
                <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
                  {project.category}
                </span>
              </div>

              <h3 className="font-default text-[22px] leading-tight mt-3 text-foreground font-semibold">
                {project.title}
              </h3>

              <p className="text-sm text-muted-foreground mt-4 font-default leading-relaxed">
                {project.description}
              </p>

              <div className="mt-6 pt-6 border-t border-border">
                <Link to={project.link} className="font-mono text-[11px] uppercase tracking-[0.18em] text-foreground border-b border-primary/30 pb-0.5 hover:border-primary transition-colors inline-flex items-center gap-2">
                  katso tästä →
                </Link>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}